/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index scroll-view to autogenerate all the fragments and extensions
 * Used by "prepareScrollViews"
 */

import ScrollView from './scroll-view/ScrollView'
export * from './scroll-view/ScrollView'
export default ScrollView
